import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { NotificationContainer } from 'react-notifications';
import { NotificationManager as N } from 'react-notifications';

import api from '../../../../services/api';
import { fileUploadImg, fileUploadAlbumImg } from '../../../../services/s3';
import MediaManagerContext from '../../MediaManagerContext';

import ButtonLoader from '../../../../components/ButtonLoader';
import RatingView from '../../../../components/RatingView';

import 'react-notifications/lib/notifications.css';
import * as S from './styles';

const Image = ({ propData }) => {

  const { viewLoading, viewError, viewContent } = useContext(MediaManagerContext);

  const [objDefault, setDefault] = useState({
    medThumbnailBanner: "https://stingr-thumbnails-media.s3.amazonaws.com/public/mediaThumbnailBanner.png",
    medThumbnailLand: "https://stingr-thumbnails-media.s3.amazonaws.com/public/mediaThumbnailLand.png",
    medThumbnailPort: "https://stingr-thumbnails-media.s3.amazonaws.com/public/mediaThumbnailPort.png",
  })
  const [objData, setData] = useState(propData)
  const [objTemp, setTemp] = useState({
    medThumbnailBanner: objData.medThumbnailBanner,
    medThumbnailLand: objData.medThumbnailLand,
    medThumbnailPort: objData.medThumbnailPort
  })
  // console.log(objData);

  const optStatus = [
    { id: 'Active', title: 'Active' },
    // { id: 'Processing', title: 'Processing' },
    { id: 'Disabled', title: 'Disabled' },
    // { id: 'Blocked', title: 'Blocked' },
  ];

  const handleCheckFiles = data => {
    console.log('#btn => Images -> Chek File');
    console.log(data)
  }

  const handleChangeFileSquare = async img => {
    console.log('#medThumbnailBanner => Upload -> Start');
    console.log(img);
    try {
      const fileUpload = await fileUploadAlbumImg(objData.albId, 'square', img[0]);
      console.log(fileUpload);

      // Validate Resolutions
      let comImage = document.createElement('img');
      comImage.src = fileUpload.link;
      comImage.onload = function() {
        // console.log(comImage.naturalWidth, comImage.naturalHeight);

        if (comImage.naturalWidth !== 1024 || comImage.naturalHeight !== 1024) {
          N.error('Image', 'Incorrect resolution');
          return false;
        }

        setTemp(prevState => {
          return {
            ...prevState,
            medThumbnailBanner: fileUpload.link,
          };
        });
        console.log('#medThumbnailBanner => Upload -> End');
      }
    } catch (e) {
      console.error(e);
      console.log('#medThumbnailBanner => Upload -> Error');
    }
  }

  const handleChangeFileBanner = async img => {
    console.log('#medThumbnailBanner => Upload -> Start');

    // console.log(img);
    try {
      const fileUpload = await fileUploadImg(
        'MEDIA',
        objData.medId,
        'banner',
        img[0]
      );
      console.log(fileUpload);

      // Validate Resolutions
      let comImage = document.createElement('img');
      comImage.src = fileUpload.link;
      comImage.onload = function() {
        // console.log(comImage.naturalWidth, comImage.naturalHeight);

        if (comImage.naturalWidth !== 3840 || comImage.naturalHeight !== 2160) {
          N.error('Image', 'Incorrect resolution');
          return false;
        }

        setTemp(prevState => {
          return {
            ...prevState,
            medThumbnailBanner: fileUpload.link,
          };
        });
        console.log('#medThumbnailBanner => Upload -> End');
      }
    } catch (e) {
      console.error(e);
      console.log('#medThumbnailBanner => Upload -> Error');
    }
  };

  const handleChangeFileLand = async img => {
    console.log('#medThumbnailLand => Upload -> Start');

    // console.log(img);
    try {
      const fileUpload = await fileUploadImg(
        'MEDIA',
        objData.medId,
        'land',
        img[0]
      );
      console.log(fileUpload);

      // Validate Resolutions
      let comImage = document.createElement('img');
      comImage.src = fileUpload.link;
      comImage.onload = function() {
        // console.log(comImage.naturalWidth, comImage.naturalHeight);

        if (comImage.naturalWidth !== 1920 || comImage.naturalHeight !== 1080) {
          N.error('Image', 'Incorrect resolution');
          return false;
        }

        setTemp(prevState => {
          return {
            ...prevState,
            medThumbnailLand: fileUpload.link,
          };
        });
        console.log('#medThumbnailLand => Upload -> End');
      }
    } catch (e) {
      console.error(e);
      console.log('#medThumbnailLand => Upload -> Error');
    }
  };

  const handleChangeFilePort = async img => {
    console.log('#medThumbnailPort => Upload -> Start');

    // console.log(img);
    try {
      const fileUpload = await fileUploadImg(
        'MEDIA',
        objData.medId,
        'port',
        img[0]
      );
      console.log(fileUpload);

      // Validate Resolutions
      let comImage = document.createElement('img');
      comImage.src = fileUpload.link;
      comImage.onload = function() {
        // console.log(comImage.naturalWidth, comImage.naturalHeight);

        if (comImage.naturalWidth !== 1040 || comImage.naturalHeight !== 1400) {
          N.error('Image', 'Incorrect resolution');
          return false;
        }

        setTemp(prevState => {
          return {
            ...prevState,
            medThumbnailPort: fileUpload.link,
          };
        });
        console.log('#medThumbnailPort => Upload -> End');
      }
    } catch (e) {
      console.error(e);
      console.log('#medThumbnailPort => Upload -> Error');
    }
  };

  const handleSubmit = async data => {
    try {
      // viewLoading();
      const data = {
        medThumbnailBanner : objTemp.medThumbnailBanner,
        medThumbnailLand : objTemp.medThumbnailLand,
        medThumbnailPort : objTemp.medThumbnailPort
      }
      console.log(`Data PUT`, data);
      const resPutData = await api('PUT', `/media/${objData.medId}/image`, data);
      console.log(resPutData);

      N.success('Successfully updated');

      setTimeout(() => {
        // history.push('/');
        // viewContent();
      }, 1000);

    } catch (error) {
      console.error(error);
      N.error('Error updating');
      // viewContent();
    }
  }

  return (
    <>
      <S.Form onSubmit={handleCheckFiles}>
        <S.DivInput propW="45%">
          <small>
            Banner <small>3840px x 2160px</small>
          </small>
          <S.LabelInputImage htmlFor="file-banner">
            <img
              src={objTemp.medThumbnailBanner}
              alt="Thumbnail Banner"
              onError={() =>
                setTemp(prevState => {
                  return {
                    ...prevState,
                    tmpThumbnailBanner: objDefault.medThumbnailBanner,
                  };
                })
              }
            />
            <input
              id="file-banner"
              type="file"
              accept="image/*"
              onChange={e => handleChangeFileBanner(e.target.files)}
            />
          </S.LabelInputImage>
        </S.DivInput>
        <S.DivInput propW="20%">
          <small>
            Portrait <small>1040px x 1400px</small>
          </small>
          <S.LabelInputImage htmlFor="file-port">
            <img
              src={objTemp.medThumbnailPort}
              alt="Thumbnail Port"
              onError={() =>
                setTemp(prevState => {
                  return {
                    ...prevState,
                    tmpThumbnailPort: objDefault.medThumbnailPort,
                  };
                })
              }
            />
            <input
              id="file-port"
              type="file"
              accept="image/*"
              onChange={e => handleChangeFilePort(e.target.files)}
            />
          </S.LabelInputImage>
        </S.DivInput>
        <S.DivInput propW="35%">
          <small>
            Landscape <small>1920px x 1080px</small>
          </small>
          <S.LabelInputImage htmlFor="file-land">
            <img
              src={objTemp.medThumbnailLand}
              alt="Thumbnail Land"
              onError={() =>
                setTemp(prevState => {
                  return {
                    ...prevState,
                    tmpThumbnailLand: objDefault.medThumbnailLand,
                  };
                })
              }
            />
            <input
              id="file-land"
              type="file"
              accept="image/*"
              onChange={e => handleChangeFileLand(e.target.files)}
            />
          </S.LabelInputImage>
        </S.DivInput>
      </S.Form>
      <S.Form onSubmit={handleSubmit}>
        <S.DivButton>
          <ButtonLoader propTitle="SAVE" propSpinner={false} />
        </S.DivButton>
      </S.Form>
      <NotificationContainer />
    </>
  );
};

Image.defaultProps = {
  propData: {},
};

Image.propTypes = {
  propData: PropTypes.object,
};

export default Image;
